import { NotFound } from "@/components/404/404";

type NotFoundPageProps = {
  onNavigate?: (path: string) => void;
};

export function NotFoundPage({ onNavigate }: NotFoundPageProps) {
  return <NotFound onNavigate={onNavigate} />;
}
